class FiskalyPtController extends FiskalyController
	@register()

	integrationId: 'fiskaly_pt'

	reset: (newConfiguration = {}) ->
		super(newConfiguration)

		@hasCredentialsPassword = @configuration.taxpayer?.fiscalization?.credentials?.password?
